"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaticContent = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var contentUtil_1 = require("../../utils/contentUtil");
var sanitize_1 = require("../../utils/sanitize");
var StaticContent = function (props) {
    var aemContent = props.aemContent, content = props.content, contentKey = props.contentKey, nameSpace = props.nameSpace, params = props.params, plainText = props.plainText, specialKey = props.specialKey, tagName = props.tagName, otherProps = __rest(props, ["aemContent", "content", "contentKey", "nameSpace", "params", "plainText", "specialKey", "tagName"]) // tslint:disable-line
    ;
    // render by one of 3 options, contentKey, children or content prop
    var contentString;
    if (contentKey) {
        contentString = (0, contentUtil_1.getContentByKey)(contentKey, params, specialKey, nameSpace, aemContent);
    }
    else if (params && content) {
        contentString = (0, contentUtil_1.getContent)(content, params);
    }
    else {
        contentString = content;
    }
    var isRenderPlainText = plainText || !(0, contentUtil_1.isHtmlString)(contentString);
    if (isRenderPlainText) {
        return (tagName ? React.createElement(tagName, otherProps, contentString) : React.createElement(React.Fragment, null, contentString));
    }
    // Wrap innerHTML
    var propsList = Object.assign(otherProps, {
        dangerouslySetInnerHTML: (0, sanitize_1.sanitize)(contentString, true),
    });
    var tag = tagName || 'span';
    return (React.createElement(tag, propsList));
};
exports.StaticContent = StaticContent;
exports.StaticContent.defaultProps = {
    plainText: false,
};
exports.StaticContent.prototype = {
    content: PropTypes.string.isRequired,
    params: PropTypes.any,
    plainText: PropTypes.bool,
    tagName: PropTypes.string,
};
